/**
 * Democratic Tools — public assets entry.
 *
 * @package DemocraticTools
 */

import { initAnalytics } from './modules/analytics.js';
import { initNavigation } from './modules/navigation.js';
import { initLanguageSelector } from './modules/language-selector.js';
import { initContentShare } from './modules/share.js';
import { initForms } from './modules/forms.js';
import { initSearch } from './modules/search.js';
import { initPreferences } from './modules/preferences.js';
import { initStorySlider } from './modules/story-slider.js';
import { initSubscriptionConfirmedToast } from './modules/subscribe-form.js';

document.addEventListener('DOMContentLoaded', () => {
  initNavigation();
  initLanguageSelector();
  initContentShare();
  initForms(globalThis.dtFormConfig);
  initSearch(globalThis.dtSearchConfig);
  initPreferences(globalThis.dtPreferencesConfig);
  initAnalytics(globalThis.dtAnalyticsConfig);
  initStorySlider();
  initSubscriptionConfirmedToast();
});
